export default defineNuxtRouteMiddleware((to, from) => {
  const myCookie = useCookie("authenticated").value;

  if (!myCookie) {
    return navigateTo(useLocalePath()('/'));
  }
});
